window.locale = 'en';
$(function(){
    window.locale = $('html').attr('lang');

    window.initAllOnObject($('body'));

    window.initTabSaving();
    window.setActiveTabs();
});

window.initTabSaving = function () {
    $('button[data-toggle="tab"]:not(.no-save)').on('show.bs.tab', function() {
        let savedTabs = JSON.parse(localStorage.getItem('activeTabs')) || {};
        
        savedTabs[$(this).parents('ul').attr('id')] = $(this).attr('data-target');

        localStorage.setItem('activeTabs', JSON.stringify(savedTabs));
    });
}

window.setActiveTabs = function() {
    let activeTabs = localStorage.getItem('activeTabs');
    $('.nav-tabs li button').first().tab('show');
    if(activeTabs){
        let activeTabsObj = JSON.parse(activeTabs);
        $.each(activeTabsObj, function (index, value) {
            $(`#${index} button[data-target="${value}"]`).tab('show');
        });
    }
}

window.snakeToCamel = function(string) {
    return string.toLowerCase().replace(/([-_][a-z])/g, group => group.toUpperCase().replace('-', '').replace('_', ''));
};

window.initSelect2 = function(items=false){
    if(items === false)
        items = $('.select2');
    
    let customSettings = {};
    items.each(function(index, element){
        let settingsAttribute = $(element).attr('data-select2-settings');
        let customSettings = JSON.parse(settingsAttribute ?? '{}');

        let defaultSettings = {
            'width': '100%',
        };

        let settings = {
            ...defaultSettings,
            ...customSettings
        }
        if($(this).parents('.modal-content').length > 0) 
            settings['dropdownParent'] = $(this).parents('.modal-content').eq(0);

        $(element).select2(settings);
    });
}

window.initSelect2Ajax = function(items=false){
    if(items === false)
        items = $('.select2_ajax');

    let customSettings = {};  
    items.each(function(index, element){
        let settingsAttribute = $(element).attr('data-select2-settings');
        let customSettings = JSON.parse(settingsAttribute ?? '{}');

        let defaultSettings = {
            'ajax': {
                'url': $(element).data('url'),
                'data': function(params){
                    let query = {};
                    query['term'] = params.term; 
                    query['page'] = params.page || 1;

                    let additionalData = $(element).data('additional');
                    if(additionalData !== undefined && additionalData["data_parameters"] !== undefined) {
                        $.each(additionalData["data_parameters"] , function (index, element) {
                            let value = $(element).val();
                            if(value) {
                                query[index] = value;
                            }
                        });
                    }

                    return query;
                }
            },
            'width': '100%',
        };

        let settings = {
            ...defaultSettings,
            ...customSettings
        }
        
        if($(this).parents('.modal-content').length > 0)
            settings['dropdownParent'] = $(this).parents('.modal-content').eq(0);
        
        $(element).select2(settings);

        $(element).on("change", function () {
            let additionalData = $(element).data('additional');
            if(additionalData !== undefined && additionalData["reset_on_change"] !== undefined){
                $.each(additionalData["reset_on_change"] , function (index, element) {
                    if(element === "select2") {
                        $(index).val(null).trigger('change.select2');
                        let event = new Event("vue_reset", {"bubbles":true, "cancelable":false});
                        $(index).get(0).dispatchEvent(event);
                    }
                });
            }
        })
    });
}


window.initDatePicker = function(items=false){
    if(items === false){
        items = $('.datepicker');
    }

    let completeLocale = window.daterangepickerLocales[window.locale];
    completeLocale['format'] = 'DD.MM.YYYY';

    items.daterangepicker({
        'singleDatePicker': true,
        'autoApply': true,
        'locale': completeLocale
    });

    items.attr('autocomplete', 'off');
}

window.initDateTimePicker = function (items = false) {
    if (items === false) {
        items = $('.date-time-picker');
    }

    let completeLocale = window.daterangepickerLocales[window.locale];
    completeLocale['format'] = 'DD.MM.YYYY HH:mm';

    let settings = {
        "opens": 'left',
        "timePicker": true,
        "timePicker24Hour": true,
        'singleDatePicker': true,
        'autoApply': true,
        'locale': completeLocale
    }

    items.each(function (index, element) {
        if ($(this).parents('.modal-content').length > 0)
            settings['parentEl'] = $(this).parents('.modal-content').eq(0);

        $(element).daterangepicker(settings);

        $(element).attr('autocomplete', 'off');
    });

}

window.initAllOnObject = function(object){
    object = $(object);

    window.initSelect2(object.find('.select2'));
    window.initSelect2Ajax(object.find('.select2_ajax'));
    window.initDatePicker(object.find('.datepicker'));
    window.initDateTimePicker(object.find('.date-time-picker'));
}